import { strToDom } from 'minsky-kit/js/utils/dom';

export function renderBlip (value, classes = []) {
    classes = ['blip', ...classes];
    return strToDom(`<span class="${classes.join(' ')}"><span class="blip__inner">${value}</span></span>`);
}

export function refreshBlips () {
    // buttons with blips
    Array.from(document.querySelectorAll('.button[data-blip]:not(.button--blip-ready)')).forEach(($btn) => {
        // $btn.innerHTML += `<span class="button__blip">${$btn.dataset.blip}</span>`;
        $btn.appendChild(renderBlip($btn.dataset.blip, ['blip--gold', 'blip--button', 'button__blip']));
        $btn.classList.add('button--blip-ready');
    });

    // menu items with blip
    const $page = document.querySelector('.page[data-take-out-reduction]');

    if ($page && $page.dataset.takeOutReduction && $page.dataset.takeOutReduction.length) {
        const value = $page.dataset.takeOutReduction;
        Array.from(document.querySelectorAll('.menu__item--id-121 .menu__link:not(.menu__link--blip-ready)')).forEach(($ml) => {
            $ml.appendChild(renderBlip(value, ['blip--white', 'blip--menu-link', 'menu__blip']));
            $ml.classList.add('menu__link--blip-ready');
        });
    }
}
